const updateQuicksight = {
  toastr: 'Usuario actualizado',
  toastr1:' fue actualizado con éxito',
  toastrError: 'Respuesta ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updateQuicksight;
